import {sendAnalyticsEvent} from '#/analytics/analytics';
import {WalletContext} from '#/contexts/wallet-provider';
import {baseKeysUseQuery} from '#/hooks/query/base/base-keys-use-query';
import {userProfileRequests} from '#/repository/fetch-user-profile';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {useContext} from 'react';

export const useUserProfileLoginMutation = () => {
  const queryClient = useQueryClient();

  const {web3Auth} = useContext(WalletContext);

  const mutation = useMutation({
    mutationFn: userProfileRequests.login,
    onSuccess: data => {
      queryClient.setQueryData([baseKeysUseQuery.useUserProfile, data.account], data);
      queryClient.setQueryData([baseKeysUseQuery.useUserProfilePrivate, data.account], data);

      sendAnalyticsEvent.login({
        method: web3Auth?.connectedAdapterName ?? '',
        ...data,
      });
    },
    retry: false,
  });

  return mutation;
};
